import url from "./url";
import baseUrl from "./baseUrl";
const AppConsts = {
  userManagement: {
    defaultAdminUserName: "admin",
  },
  localization: {
    defaultLocalizationSourceName: "EzS",
  },
  authorization: {
    encrptedAuthTokenName: "enc_auth_token",
  },

  appBaseUrl: baseUrl,
  remoteServiceBaseUrl: url,
  isUrl: process.env.VUE_APP_IS_URL,
  storageType: {
    serial: "SRL",
    nonserial: "N_SRL",
  },
  productTypes: {
    goods: "GOODS",
    service: "SERVICE",
  },
  productServiceDefaultValues: {
    type: "SNGL",
    inventModel: "N_DFN",
    storageType: "N_SRL",
  },
  viewTimeDateFormat: "hh:mm:ss A DD/MM/YYYY",
  reportDateFormat: "YYYY-MM-DD",
  viewDateFormat: "DD/MM/YYYY hh:mm:ss A",
  viewNumberFormat: "en-US",
  datePickerFormatString: "DD/MM/YYYY",
  backlogDateFormat: "DD/MM",
  monthYearFormat: "MM/YYYY",
  viewShortTimeDateFormat: "HH:mm DD/MM/YYYY",
  maximumFractionDigits: 10,
  unicodeRegexPattern: "[^\u0000-\u007F]+",
  specialCharRegexPattern: "[!@#$%^&,]+$",
  numberRegexPattern: /^([1-9][0-9]*)$/,
  productSkuRegexPattern: /^[sS](\d{10})$/,
  warrantedAccording: {
    Day: "DAY",
    Month: "MONTH",
    Year: "YEAR",
  },
  tableRef: {
    tableProduct: {
      name: "wms.Product",
      column: {
        storageType: "StorageType",
        inventModel: "InventModel",
        productType: "ProductType",
        type: "Type",
      },
      prefix: {
        storageType: "StorageType",
        productType: "ProductType",
        type: "Type",
      },
    },
    tablePo: {
      name: "wms.Po",
      column: {
        status: "Status",
        type: "Type",
        productType: "ProductType",
        buyFrom: 'BuyFrom'
      },
      prefix: {
        status: "PoStatus_",
        type: "PoType_",
        productType: "PoProductType",
        buyFrom: "PoBuyFrom",
      },
    },
    tablePl: {
      name: "wms.Pl",
      column: {
        type: "Type",
        status: "Status",
      },
    },
    tableWh: {
      name: "wms.Warehouse",
      column: {
        inboundMode: "InboundMode",
      },
    },
    tablePoLineException: {
      name: "wms.PoLineException",
      column: {
        type: "Type",
      },
    },
    tableCustomer: {
      name: "wms.Customer",
      column: {
        type: "Type",
      },
      prefix: {
        type: "CustomerType",
      },
    },
    tableLocation: {
      name: "wms.Location",
      column: {
        type: "Type",
      },
    },
    tableCaseLabel: {
      name: "wms.CaseLabel",
      column: {
        status: "StatusCode",
      },
      prefix: {
        status: "CaseLabelStatus",
      },
    },
    tableSOR: {
      name: "wms.SoRequest",
      column: {
        status: "StatusCode",
      },
      prefix: {
        status: "SORStatus",
        actionType: "SORActionType",
      },
    },
    tableDeliveryNote: {
      name: "wms.DeliveryNote",
      column: {
        status: "StatusCode",
      },
      prefix: {
        status: "DeliveryNoteStatus",
      },
    },
  },
  permissionNames: {
    createProduct: "Pages.CreateProduct",
    updateProduct: "Pages.UpdateProduct",
    deleteProduct: "Pages.DeleteProduct",
    createPo: "Pages.CreatePurchaseOrder",
    updatePo: "Pages.UpdatePurchaseOrder",
    recheckSalesOrder: "Operations.SalesOrders.Recheck",
    cancelPurchaseOrder: "Operations.PurchaseOrders.Cancel",
    finishPurchaseOrder: "Operations.PurchaseOrders.Finish",
    cancelSalesOrder: "Operations.SalesOrders.Cancel",
    rejectSalesOrder: "Operations.SalesOrders.Reject",
    recheckAllPreOrders: "Operations.SalesOrderRequests.RecheckAll",
    resolveLostIssue: "Operations.LostFoundIssue.Resolve",
    updatePurchaseOrder: "Operations.PurchaseOrders.Update",
    cancelTOReq: "Operations.TransferOrders.Cancel",
    returnSalesOrder: "Operations.SalesOrders.Return",
    cancelSalesOrderRequest: "Operations.SalesOrderRequests.Cancel",
    createSalesOrder: "Operations.SalesOrders.Create",
    rejectSalesOrderRequest: "Operations.SalesOrderRequests.Reject",
    finishSalesOrderRequest: "Operations.SalesOrderRequests.Finish",
    viewSalesOrderRequest: "Operations.SalesOrderRequests.View",
    recheckPreOrders: "Operations.SalesOrderRequests.Recheck",
    returnDeliveryNote: "Operations.ReceivingDelivering.DeliveryNotes.Return",
    viewPurchaseOrder: "Operations.PurchaseOrders.View",
    exportWarrantyActivation: "EWarranty.ExportWarrantyActivation",
  },
  inventoryReportType: {
    operation: 1,
    admin: 2,
    client: 3,
  },
  rootFolderImage: "files/LocalAssets/",
  refType: {
    PurchaseOrder: "PO",
    SaleOrder: "SO",
    TransferOrder: "TO",
    Transport: "TP",
    Task: "TSK",
    Client: "CLT",
    Tpl: "TPL",
  },
  pageSize: 10,
  pageSmallSize: 5,
  dashboardBacklogInfo: {
    rangeDate: 7,
    lineChartProp: {
      pointBackgroundColor: "#BD2841",
      fill: false,
      borderWidth: 4,
      steppedLine: false,
    },
    inboundBackgroundColor: {
      NEW: "#65DADA",
      NEED_RECEIVE: "#BD2841",
      READY_PUTAWAY: "#6A69AE",
      PUTAWAYING: "#EBD466",
    },
    outboundBackgroundColor: {
      NEW: "#65DADA",
      RT_PICK: "#BD2841",
      PICKING: "#EBD466",
      PACKING: "#36A2EB",
      RT_SHIP: "#6A69AE",
      PICKED: "#DB8AB4",
    },
    woStatBackgroundColor: {
      DOING: "#65DADA",
      BACKLOG: "#BD2841",
      DONE: "#EBD466",
    },
    empStatBackgroundColor: {
      WORKING: "#65DADA",
      AVAILABLE: "#BD2841",
    },
  },
  refTypeForPickWave: ["SO", "TO"],
  soStatusCreatePw: ["NEW", "PA"],
  prefixConsts: {
    plType: "PlType",
    ref: "Ref",
    plStatus: "PlStatus",
    assetType: "AssetType_",
    conditionType: "ConditionType_",
    locationType: "LocationType_",
  },
  poLineExceptionOperator: {
    increase: "Increase",
    decrease: "Decrease",
  },
  poStatus: {
    finish: "FNSH",
    new: "NEW",
  },
  soStatus: {
    preOrder: "PREORDER",
    new: "NEW",
    canceled: "CNCL",
    pa: "PA",
    picked_par: "PICKED_PAR",
    packing: "PACKING",
    picking: "PICKING",
    shipped: "SHIPPED",
    delivered: "DELIVERED",
    delivering: "DELIVERING",
    returning: "RETURNING",
    returned: "RETURNED",
    ship_par: "SHIP_PAR",
  },
  handoverSessionStatus: {
    new: "NEW",
    canceled: "CNCL",
    transferred: "TRANSFERRED",
  },
  defaultCountry: "VN",
  All: "All",
  allItemValue: "_ALL",
  warehouseLogo: "Template.WarehouseLogo",
  featureConditionType: {
    PO_Create: "PO_CREATE",
    Receive_Exception: "RECEIVE_EXCEPTION",
    SO_Create: "SO_CREATE",
    TO_Create: "TO_CREATE",
    Report: "REPORT",
  },
  poTypes: {
    standard: "STD",
    returnSalesOrder: "RO",
    returnOrderHTH: "RO_HTH",
    crmReturnOrder: "CRM_RO",
    returnSalesOrderAfterPack :"CNL_AF_PACK",
    ship:"SHIP"
  },

  keyWordAtleastLength: 3,
  inputChannel: {
    API_CRM: "API_CRM",
  },
  debounceDelayTime: 300,
  inventoryReportDetailType: {
    waitingInPO: "WAITINGIN_PO",
    waitingInTO: "WAITINGIN_TO",
    waitingOutSO: "WAITINGOUT_SO",
    waitingOutTO: "WAITINGOUT_TO",
  },
  statusesGroupPackage: ["_ALL", "PACKED", "RT_SHIP", "SHIPPED"],
  reportRangeDays: {
    range45: 45,
    range180: 180,
    range15: 15,
  },
  poProductType: {
    LK: "LK",
    TP: "TP",
  },
  locationType: {
    bin: "BIN",
    transport: "TRNSPRT",
  },
  paperSizeDicInPointUnitPT: [
    {
      name: "TEM_2_10070",
      width: 284,
      height: 200,
      realHeight: 150,
      itemsPerPage: 2,
    }, //[283.464566929, 198.42519685], // 100x70
    {
      name: "TEM_2_10030",
      width: 284,
      height: 85,
      realHeight: 85,
      itemsPerPage: 2,
    }, //[283.464566929, 85.039370079], // 100x30
  ],
  collectionCodePaperSizeDicInPointUnitPT: [
    {
      name: "TEM_2_10070",
      width: 284,
      height: 200,
      realHeight: 150,
      itemsPerPage: 2,
    }, //[283.464566929, 198.42519685], // 100x70
    {
      name: "TEM_3_10022",
      width: 284,
      height: 80,
      realHeight: 80,
      itemsPerPage: 3,
    }, //[283.464566929, 85.039370079], // 100x22
  ],
  sorStatus: {
    draft: "NEW",
    preview: "PREVIEW",
    approved: "APPROVED",
    finished: "FINISHED",
    canceled: "CANCEL",
    processing: "PROCESSING",
    rejected: "REJECTED",
    preOrder: "PREORDER",
  },
  discountTypePrefix: "DiscountType",
  deliveryNoteStatus: {
    returning: "RETURNING",
    returned: "RETURNED",
    finished: "FINISHED",
  },
  identityUserAppRoles: ["WMS", "CRM", "DMS"],
  identityUserAppRoleDefault: "WMS",
  appBaseImageUrl: process.env.VUE_APP_BASE_IMAGE_URL,
  collectionCodeTypes: [
    {
      code: "hiddenCode",
      name: "HiddenCode",
    },
    {
      code: "mainSerialNo",
      name: "MainSerialNo",
    },
    {
      code: "subSerialNo",
      name: "SubSerialNo",
    },
  ],
  notificationObjectTypes:
    {
      SOR_APPROVED: "SOR_APPROVED",
      SO_CREATED: "SO_CREATED",
      PO_CREATED:"PO_CREATED",
      PO_CRM_RO_CREATED:"PO_CRM_RO_CREATED",
      PO_RO_CREATED:"PO_RO_CREATED",
      PO_CNL_AF_PACK_CREATED:"PO_CNL_AF_PACK_CREATED",
      PO_SHIP_CREATED:"PO_SHIP_CREATED",
      PO_TRSFR_CREATED:"PO_TRSFR_CREATED"
    },
    
};
export default AppConsts;
